import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
	DocumentPatient,
	MobilePatient,
	MutuelleAttestationPatient,
	Patient,
} from "@jack-sparrow-libraries/emotion-models";
import { Logger, LogManager, MutuelleAttestationPatientHelperService } from "features";

/*
  Generated class for the MobilePatientProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable({ providedIn: "root" })
export class ModificationMutuelleAttestationPatientApiService {
	logger: Logger;

	constructor(
		@Inject("configuration")
		private configuration: any,
		private ampHelperService: MutuelleAttestationPatientHelperService,

		private http: HttpClient,
		logManager: LogManager,
	) {
		this.logger = logManager.getLogger(this.constructor.name);
	}

	loadPatient(patientId: number): Observable<Patient> {
		return this.http.get<Patient>(`${this.configuration.apiEmotion()}/patients/${patientId}`);
	}

	loadMobilePatient(patientId: number): Observable<MobilePatient> {
		return this.http.get<MobilePatient>(`${this.configuration.api()}/patients/${patientId}`);
	}

	updateMutuelleAttestationPatient(
		mutuelleAttestation: MutuelleAttestationPatient,
	): Observable<MutuelleAttestationPatient> {
		return this.http.post<MutuelleAttestationPatient>(
			`${this.configuration.apiEmotion()}/mutuelleAttestationPatient/updateMutuelleAttestationPatient`,
			mutuelleAttestation,
		);
	}

	updateDocumentMutuelleAttestation(
		documentMutuelle: DocumentPatient,
		idPatient: number,
	): Observable<DocumentPatient> {
		return this.http.post<DocumentPatient>(
			`${this.configuration.apiEmotion()}/document/saveDocumentPatient`,
			documentMutuelle,
		);
	}

	saveMutuelleAttestationPatient(amp: MutuelleAttestationPatient): Observable<MutuelleAttestationPatient> {
		amp.critereSecondaire = this.ampHelperService.replaceEmptyCSRValueForApi(amp.critereSecondaire);
		return this.http.post<MutuelleAttestationPatient>(
			`${this.configuration.apiEmotion()}/mutuelleAttestationPatient/createMutuelleAttestationPatientFromOrdoAndCheckConvention`,
			amp,
		);
	}
}
